import { inject, Injectable } from '@angular/core';
import { IrisConfirmationService } from '@iris/common/services/confirmation.service';
import { from, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IrisDmsAlertsSandbox {
  private readonly confirmationService = inject(IrisConfirmationService);

  public showActionConfirmation(message: string, undoAction?: () => void, confirmAction?: () => void): Promise<void> {
    return this.confirmationService
      .show(
        message,
        'label.dms.ConfirmAction',
        'label.dms.UndoAction',
      )
      .then(() => confirmAction?.())
      .catch(() => undoAction?.());
  }

  public showActionConfirmation$(message: string, undoAction?: () => void, confirmAction?: () => void): Observable<unknown> {
    return from(this.confirmationService.show(
      message,
      'label.dms.ConfirmAction',
      'label.dms.UndoAction',
    )).pipe(
      tap(() => confirmAction?.()),
      catchError(() => {
        if (undoAction) {
          return of(undoAction());
        }
        throw new Error();
      }),
    );
  }
}
